import type { MetaModalData } from '../settings/types/meta';
import { getSlugFromPage } from '../../utils/routeUtils';
import {
  isMetaOAuthStateParam,
  persistMetaOAuthCallbackFromUrl,
} from '../../services/modules/metaSDK';

const MODAL_KEY = 'adlitics_meta_oauth_modal';
export const META_MODAL_READY_EVENT = 'adlitics:meta-modal-ready';

/** Resultado do OAuth (sobrevive unmount / redirect acidental). */
export function stashMetaModal(data: MetaModalData): void {
  sessionStorage.setItem(MODAL_KEY, JSON.stringify(data));
}

export function hasStashedMetaModal(): boolean {
  return sessionStorage.getItem(MODAL_KEY) !== null;
}

/** Lê sem consumir — Strict Mode / remount não perde o modal. */
export function readMetaModal(): MetaModalData | null {
  const raw = sessionStorage.getItem(MODAL_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as MetaModalData;
  } catch {
    return null;
  }
}

export function clearMetaModalStash(): void {
  sessionStorage.removeItem(MODAL_KEY);
}

function hasPersistedMetaPendingCode(): boolean {
  return Boolean(
    sessionStorage.getItem('adlitics_meta_oauth_pending_code') ||
      localStorage.getItem('adlitics_meta_oauth_pending_code'),
  );
}

function hasMetaConnectingFlag(): boolean {
  return (
    sessionStorage.getItem('adlitics_meta_connecting') === 'true' ||
    localStorage.getItem('adlitics_meta_connecting') === 'true' ||
    Boolean(
      sessionStorage.getItem('adlitics_meta_oauth_state') ||
        localStorage.getItem('adlitics_meta_oauth_state'),
    )
  );
}

export function hasPendingMetaOAuthCallback(): boolean {
  // Captura imediata: sobrevive a gates que limpam a query antes do exchange.
  persistMetaOAuthCallbackFromUrl();

  if (hasPersistedMetaPendingCode()) return true;

  const params = new URLSearchParams(window.location.search);
  if (!params.has('code') || !params.has('state')) return false;

  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const igSlug = getSlugFromPage('connections');
  if (path === `/${igSlug}` || path.endsWith(`/${igSlug}`)) return false;

  // Instagram OAuth usa o mesmo ?code=&state= — não tratar como Meta
  if (
    sessionStorage.getItem('adlitics_instagram_connecting') === 'true' ||
    sessionStorage.getItem('adlitics_instagram_oauth_state') ||
    localStorage.getItem('adlitics_instagram_oauth_state')
  ) {
    return false;
  }

  const state = params.get('state');
  // state Meta = nonce.orgId — não depende de sessionStorage (Facebook WebView limpa)
  if (isMetaOAuthStateParam(state)) return true;

  return hasMetaConnectingFlag();
}

/** Callback na URL/storage, exchange em andamento, ou modal pronto para abrir. */
export function isMetaOAuthFlowActive(): boolean {
  return (
    hasPendingMetaOAuthCallback() ||
    hasMetaConnectingFlag() ||
    hasStashedMetaModal()
  );
}
